import ValidationMessageComponent from './validation-message.component'

const ValidationMessageModule = angular.module('cdbl.validation-message', [

])
  .component('cdblValidationMessage', ValidationMessageComponent)
  .name

export default ValidationMessageModule
